import { render, staticRenderFns } from "./JeecgTreeTable.vue?vue&type=template&id=27c14ef4&scoped=true"
import script from "./JeecgTreeTable.vue?vue&type=script&lang=js"
export * from "./JeecgTreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c14ef4",
  null
  
)

export default component.exports